import { Card, Input, CardBody, Button, CardFooter, useSelect } from "@heroui/react"
import { useState } from "react"
import { ErrorCard, MainContainer } from "../components"
import { useSelector } from "react-redux"
import { toast } from "react-toastify"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons"
import { usePost } from "../api/reactQueryCustomHooks"
import { apiRoute } from "../constants/enum"

const Authenticationkey = () => {
    const { user } = useSelector((state) => state.auth)
    const [isVisible, setIsVisible] = useState(false)
    const toggleVisibility = () => setIsVisible(!isVisible)

    let [msg, setMsg] = useState("")
    let [msgPwd, setMsgPWD] = useState("")
    let [formData, setFormData] = useState({
        password: "",
        confirmPassword: ""
    })
    const handleChange = (e) => {
        const { value, name } = e.target;
        setFormData({ ...formData, [name]: value })
        if (name == "password") {
            if (value.length<5) {
                setMsgPWD("Key must have atleast 5 character")
            }
            else {
                setMsgPWD("")
               
            }

        }
    }
    const onSuccessTasks = (data) => {
        toast.success("Secuirty Key Is Set", {
            position: "top-center"
        })
    }
    const resetValues = () => {
        setFormData({})
        setMsg("")
        setMsgPWD("")
    }
    const { isPending, isError, mutate: funWebAdmPwd } = usePost({
        url: apiRoute.setWebAdmPassword,
        queryKey: "AuthenticationKeySet",
        onSuccessTasks,
        resetValues

    })
    if (isError) {
        return <ErrorCard />
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        if (formData.confirmPassword.trim() !== formData.password.trim()) {
            toast.error("Confirm Key Should Be Same As Authentication Key", {
                position: "top-center"
            })
        }
        if (msg) {
            toast.error(msg, {
                position: "top-center"
            })
        }
        if (msgPwd) {
            toast.error(msgPwd, {
                position: "top-center"
            })
        }
        if (msgPwd == "" && msg == "" && formData.confirmPassword.trim() == formData.password.trim()) {
            funWebAdmPwd({
                data: {
                    adm_key: formData.password
                }
            })
        }
    }
    return (
        <div>
            <MainContainer pageName="Authentication Key" breadcrumbs={["Settings", "Authentication Key"]}>

                {/* <h2 className="mb-4 text-center font-bold leading-none tracking-tight
                 text-gray-900 md:text-1xl lg:text-xl dark:text-white" >Reset Password</h2> */}
                <div className=" shadow pb-5  min-w-md">
                    <div className="  pb-5 flex flex-col item-center">
                        <form onSubmit={handleSubmit}>

                            <div className="items-center gap-2 px-5">
                                <Input
                                    isRequired
                                    label="Authentication Key"
                                    placeholder=" "
                                    size="md"
                                    labelPlacement="outside"
                                    name="password"
                                    className=" font-semibold"
                                    variant="bordered"
                                    value={formData.password}
                                    onChange={handleChange}
                                    endContent={
                                        <button
                                            className="focus:outline-none"
                                            type="button"
                                            onClick={toggleVisibility}
                                        >
                                            {isVisible ? (
                                                <FontAwesomeIcon icon={faEyeSlash} />
                                            ) : (
                                                <FontAwesomeIcon icon={faEye} />
                                            )}
                                        </button>
                                    }
                                    type={isVisible ? "text" : "password"}

                                />
                                <div className="alert alert-danger text-sm text-red-800">
                                    {msgPwd}
                                </div>
                            </div>
                            <div className="items-center gap-2 p-5">
                                <Input
                                    isRequired
                                    label="Confirm Key"
                                    placeholder=" "
                                    size="md"
                                    labelPlacement="outside"
                                    name="confirmPassword"
                                    value={formData.confirmPassword}
                                    className=" font-semibold"
                                    variant="bordered"
                                    onChange={handleChange}
                                    endContent={
                                        <button
                                            className="focus:outline-none"
                                            type="button"
                                            onClick={toggleVisibility}
                                        >
                                            {isVisible ? (
                                                <FontAwesomeIcon icon={faEyeSlash} />
                                            ) : (
                                                <FontAwesomeIcon icon={faEye} />
                                            )}
                                        </button>
                                    }
                                    type={isVisible ? "text" : "password"}

                                />
                            </div>


                            <div className="flex justify-center">
                                <Button color="primary" type="submit" size="sm" isLoading={isPending} >
                                    Set Key
                                </Button>
                            </div>


                        </form>


                    </div>
                </div>
            </MainContainer>
        </div>
    )
}
export default Authenticationkey